<template>
  <div style="min-height: calc(100vh - 176px)" class="flex flex-wrap mt-4">
    <div 
      class="relative py-2 px-2 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0" 
      style="min-height: calc(-176px + 100vh);"
    >
      <div class="container mx-auto px-4 py-4">
        <h1 class="text-2xl font-bold mb-4">
          {{ isEditing ? "Редактировать профиль эксперта" : "Создать профиль эксперта" }}
        </h1>

        <form @submit.prevent="saveExpert" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Пользователь</label>
            <select v-model="expert.user" required
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            >
              <option disabled value="">Выберите пользователя</option>
              <option v-for="user in users" :key="user.id" :value="user.id">
                {{ user.fio }} ({{ user.email || 'Нет email' }})
              </option>
            </select>
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Специализация</label>
            <input
              type="text"
              v-model="expert.specialization"
              placeholder="Введите специализацию"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Биография</label>
            <textarea
              v-model="expert.bio"
              rows="4"
              placeholder="Введите краткую биографию"
              :class="getExpertTextFieldClass('bio')"
            ></textarea>
            <div :class="getExpertTextCounterClass('bio')">
              {{ getExpertTextLength('bio') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('bio')" class="text-red-500">{{ getExpertTextError('bio') }}</small>
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Достижения</label>
            <textarea
              v-model="expert.achievements"
              rows="4"
              placeholder="Введите достижения"
              :class="getExpertTextFieldClass('achievements')"
            ></textarea>
            <div :class="getExpertTextCounterClass('achievements')">
              {{ getExpertTextLength('achievements') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('achievements')" class="text-red-500">{{ getExpertTextError('achievements') }}</small>
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Образование</label>
            <textarea
              v-model="expert.education"
              rows="4"
              placeholder="Введите краткую биографию"
              :class="getExpertTextFieldClass('education')"
            ></textarea>
            <div :class="getExpertTextCounterClass('education')">
              {{ getExpertTextLength('education') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('education')" class="text-red-500">{{ getExpertTextError('education') }}</small>
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Опыт</label>
            <textarea
              v-model="expert.experience"
              rows="4"
              placeholder="Введите опыт работы"
              :class="getExpertTextFieldClass('experience')"
            ></textarea>
            <div :class="getExpertTextCounterClass('experience')">
              {{ getExpertTextLength('experience') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('experience')" class="text-red-500">{{ getExpertTextError('experience') }}</small>
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Полное описание</label>
            <textarea
              v-model="expert.content"
              rows="4"
              placeholder="Введите полное описание"
              :class="getExpertTextFieldClass('content')"
            ></textarea>
            <div :class="getExpertTextCounterClass('content')">
              {{ getExpertTextLength('content') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('content')" class="text-red-500">{{ getExpertTextError('content') }}</small>
          </div>

          <!-- <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Рейтинг</label>
            <input
              type="number"
              step="0.1"
              v-model="expert.rating"
              placeholder="Введите рейтинг эксперта"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div> -->

          <!-- <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Количество оценок</label>
            <input
              type="number"
              v-model="expert.rating_count"
              placeholder="Введите количество оценок"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div> -->

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Фото</label>
            <input type="file" @change="handlePhotoUpload" accept="image/*" />
            <div v-if="photoPreview" class="mt-2">
              <img :src="photoPreview" alt="Preview" class="w-32 h-32 object-cover rounded" />
            </div>
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">Курсы, которые ведёт эксперт</label>
            <select
              v-model="expert.course_ids"
              multiple
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            >
              <option v-for="course in coursesList" :key="course.id" :value="course.id">
                {{ course.title }}
              </option>
            </select>
          </div>

          <div class="border-t-2 pt-6 mt-6">
            <h3 class="text-lg font-bold mb-4">Информация о пилоте</h3>

            <!-- Pending Verification Status -->
            <div v-if="expert.is_pilot_pending_verification" class="mb-4 bg-yellow-50 p-3 rounded border border-yellow-300">
              <p class="text-yellow-800 font-semibold">⏳ Запрос на проверку на рассмотрении</p>
              <p class="text-yellow-700 text-sm mt-1">Эксперт отправил запрос на подтверждение статуса пилота</p>
              <div class="mt-3 flex gap-2">
                <button
                  type="button"
                  @click="approvePilotVerification"
                  class="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold py-1 px-3 rounded"
                >
                  Подтвердить
                </button>
                <button
                  type="button"
                  @click="rejectPilotVerification"
                  class="bg-red-600 hover:bg-red-700 text-white text-sm font-semibold py-1 px-3 rounded"
                >
                  Отклонить
                </button>
              </div>
            </div>

            <div class="mb-4">
              <label class="flex items-center">
                <input
                  type="checkbox"
                  v-model="expert.is_pilot"
                  class="rounded"
                />
                <span class="ml-2 text-gray-700 font-bold">Отметить как пилота</span>
              </label>
            </div>

            <div v-if="expert.is_pilot" class="mb-4">
              <label class="block text-gray-700 text-sm font-bold mb-2">Категория пилота</label>
              <select
                v-model="expert.pilot_category"
                required
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              >
                <option disabled value="">Выберите категорию</option>
                <option value="first">Первая категория</option>
                <option value="second">Вторая категория</option>
                <option value="third">Третья категория</option>
              </select>
            </div>

            <div v-if="expert.is_pilot" class="mb-4">
              <label class="block text-gray-700 text-sm font-bold mb-2">Сертификат пилота (PDF/JPG)</label>
              <input
                type="file"
                @change="handleCertificateUpload"
                accept=".pdf,.jpg,.jpeg,.png"
                class="block w-full text-sm text-gray-500
                  file:mr-4 file:py-2 file:px-4
                  file:rounded file:border-0
                  file:text-sm file:font-semibold
                  file:bg-blue-50 file:text-blue-700
                  hover:file:bg-blue-100"
              />
              <div v-if="certificatePreview" class="mt-2">
                <a :href="certificatePreview" target="_blank" class="text-blue-600 hover:text-blue-800 underline">
                  Просмотр загруженного сертификата
                </a>
              </div>
            </div>

            <div v-if="expert.is_pilot" class="mb-4">
              <label class="block text-gray-700 text-sm font-bold mb-2">Виды услуг пилота</label>
              <div class="space-y-2">
                <div v-for="service in availablePilotServices" :key="service.value">
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      :value="service.value"
                      v-model="expert.pilot_services"
                      class="rounded"
                    />
                    <span class="ml-2 text-gray-700">{{ service.label }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="flex gap-2 mt-4">
            <button
              type="submit"
              :disabled="expertTextHasErrors"
              :class="[
                'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded',
                expertTextHasErrors && 'opacity-50 cursor-not-allowed hover:bg-blue-500'
              ]"
            >
              Сохранить
            </button>
            <button type="button" @click="$router.push('/admin/experts')" class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">
              Назад
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_EXPERTS, HEADERS_TOKEN_JSON_FILE, HEADERS_TOKEN_JSON, API_COURSES, API_PILOT_SERVICES_PUBLIC } from '@/const/uri';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      expert: {
        user: '',
        specialization: '',
        bio: '',
        achievements: '',
        education: '',
        experience: '',
        content: '',
        photo: null,
        course_ids: [],
        is_pilot: false,
        pilot_category: '',
        pilot_certificate: null,
        pilot_services: [],
        is_pilot_pending_verification: false,
      },
      users: [],
      coursesList: [],
      isEditing: false,
      photoFile: null,
      photoPreview: null,
      certificateFile: null,
      certificatePreview: null,
      availablePilotServices: [],
      expertTextMaxLength: 5000,
      expertTextFields: [
        { key: 'education', label: 'Образование' },
        { key: 'bio', label: 'Биография' },
        { key: 'experience', label: 'Опыт' },
        { key: 'achievements', label: 'Достижения' },
        { key: 'content', label: 'Полное описание' },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.loadData();
      }
    },
  },
  computed: {
    expertTextHasErrors() {
      return this.expertTextFields.some(field => this.isExpertTextFieldInvalid(field.key));
    },
  },
  methods: {
    ...mapActions(['toggleAlert']),
    getExpertTextLength(field) {
      return String(this.expert?.[field] || '').length;
    },
    isExpertTextFieldInvalid(field) {
      return this.getExpertTextLength(field) > this.expertTextMaxLength;
    },
    getExpertTextError(field) {
      const length = this.getExpertTextLength(field);
      if (length <= this.expertTextMaxLength) return '';
      return `Введено ${length} из ${this.expertTextMaxLength} символов. Пожалуйста, сократите текст`;
    },
    getExpertTextFieldClass(field) {
      return [
        'shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline',
        this.isExpertTextFieldInvalid(field) && 'border-red-500 bg-red-50',
      ];
    },
    getExpertTextCounterClass(field) {
      return [
        'text-xs mt-1 text-right',
        this.isExpertTextFieldInvalid(field) ? 'text-red-500' : 'text-gray-500',
      ];
    },
    showExpertTextLimitAlert() {
      const invalidField = this.expertTextFields.find(field => this.isExpertTextFieldInvalid(field.key));
      if (!invalidField) return;

      this.toggleAlert({
        message: `${invalidField.label}: ${this.getExpertTextError(invalidField.key)}`,
        isError: true,
      });
    },
    flattenErrorMessages(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value.flatMap(item => this.flattenErrorMessages(item));
      if (typeof value === 'object') return Object.values(value).flatMap(item => this.flattenErrorMessages(item));
      return [String(value)];
    },
    getApiErrorMessage(error, fallback) {
      const data = error.response?.data;
      const messages = this.flattenErrorMessages(data?.errors || data?.error || data?.detail || data);
      return messages.join('; ') || fallback;
    },
    async loadData() {
      await this.fetchPilotServices();
      await this.fetchUsers();
      await this.fetchCourses();
      if (this.$route.params.id) {
        await this.fetchExpert();
      }
    },
    async fetchPilotServices() {
      try {
        const response = await axios.get(API_PILOT_SERVICES_PUBLIC.list, { headers: HEADERS_TOKEN_JSON() });
        const services = response.data.data || [];
        this.availablePilotServices = services.map(service => ({
          value: service.key,
          label: service.name
        }));
      } catch (error) {
        console.error('Error fetching pilot services:', error);
        this.availablePilotServices = [
        ];
      }
    },
    async fetchCourses() {
      try {
        const response = await axios.get(API_COURSES.admin, { headers: HEADERS_TOKEN_JSON() });
        if (response.data.code === 0) {
          this.coursesList = response.data.data;
        }
      } catch (error) {
        console.error('Ошибка загрузки курсов:', error);
      }
    },
    async fetchUsers() {
      try {
        const params = {};
        if (!this.$route.params.id) {
          params.exclude_existing = 1;
        }
        const response = await axios.get(API_EXPERTS.users, { headers: HEADERS_TOKEN_JSON(), params });
        if (response.data.code === 0) {
          this.users = response.data.data.results;
        }
      } catch (error) {
        console.error('Ошибка загрузки пользователей:', error);
      }
    },
    async fetchExpert() {
      const id = this.$route.params.id;
      if (!id) return;

      const params = {};
      if(this.$route.query.is_user) {
        params.is_user = this.$route.query.is_user;
      }

      try {
        const response = await axios.get(`${API_EXPERTS.list}${id}/`, {
          headers: HEADERS_TOKEN_JSON(),
          params,
        });
        if (response.data.code === 0) {
          const data = response.data.data;
          if(data.is_created) {
            this.$router.push({
              name: 'ExpertEdit',
              params: { id: data.expert.id },
            });
          }
          const expertData = data.expert;
          this.expert = {
            user: expertData.user_id || '',
            specialization: expertData.specialization || '',
            bio: expertData.bio || '',
            achievements: expertData.achievements || '',
            education: expertData.education || '',
            experience: expertData.experience || '',
            content: expertData.content || '',
            // rating: expertData.rating || 0,
            // rating_count: expertData.rating_count || 0,
            course_ids: (expertData.courses || []).map(course => course.id),
            is_pilot: expertData.is_pilot || false,
            pilot_category: expertData.pilot_category || '',
            pilot_certificate: expertData.pilot_certificate || null,
            pilot_services: expertData.pilot_services || [],
            is_pilot_pending_verification: expertData.is_pilot_pending_verification || false,
          };

          if (expertData.photo) {
            this.photoPreview = expertData.photo;
          }

          if (expertData.pilot_certificate) {
            this.certificatePreview = expertData.pilot_certificate;
          }

          this.isEditing = true;
        }
      } catch (error) {
        console.error('Ошибка загрузки эксперта:', error);
      }
    },
    handlePhotoUpload(event) {
      this.photoFile = event.target.files[0];
      if (this.photoFile) {
        this.photoPreview = URL.createObjectURL(this.photoFile);
      }
    },
    handleCertificateUpload(event) {
      this.certificateFile = event.target.files[0];
      if (this.certificateFile) {
        this.certificatePreview = URL.createObjectURL(this.certificateFile);
      }
    },
    approvePilotVerification() {
      if (!this.expert.pilot_category) {
        alert('Сначала выберите категорию пилота');
        return;
      }
      this.expert.is_pilot = true;
      this.expert.is_pilot_pending_verification = false;
      alert('Статус пилота одобрен');
    },
    rejectPilotVerification() {
      this.expert.is_pilot = false;
      this.expert.is_pilot_pending_verification = false;
      this.expert.pilot_category = '';
      this.expert.pilot_certificate = null;
      this.expert.pilot_services = [];
      alert('Запрос на проверку отклонен');
    },
    async saveExpert() {
      if (this.expertTextHasErrors) {
        this.showExpertTextLimitAlert();
        return;
      }

      let formData = new FormData();
      formData.append('user', this.expert.user);
      formData.append('specialization', this.expert.specialization);
      formData.append('bio', this.expert.bio);
      formData.append('achievements', this.expert.achievements);
      formData.append('education', this.expert.education);
      formData.append('experience', this.expert.experience);
      formData.append('content', this.expert.content);
      this.expert.course_ids.forEach(courseId => {
        formData.append('course_ids', courseId);
      });
      if (this.photoFile) {
        formData.append('photo', this.photoFile);
      }

      // Add pilot fields
      formData.append('is_pilot', this.expert.is_pilot);
      formData.append('is_pilot_pending_verification', this.expert.is_pilot_pending_verification);
      if (this.expert.is_pilot || this.expert.is_pilot_pending_verification) {
        formData.append('pilot_category', this.expert.pilot_category);
        if (this.certificateFile) {
          formData.append('pilot_certificate', this.certificateFile);
        }
        // Add pilot services as JSON array
        formData.append('pilot_services', JSON.stringify(this.expert.pilot_services));
      }

      try {
        if (this.isEditing) {
          await axios.patch(`${API_EXPERTS.list}${this.$route.params.id}/`, formData, {
            headers: HEADERS_TOKEN_JSON_FILE(),
          });
        } else {
          await axios.post(API_EXPERTS.list, formData, {
            headers: HEADERS_TOKEN_JSON_FILE(),
          });
        }
        this.$router.push('/admin/experts');
      } catch (error) {
        console.error('Ошибка сохранения эксперта:', error);
        this.toggleAlert({
          message: this.getApiErrorMessage(error, 'Ошибка сохранения эксперта'),
          isError: true,
        });
      }
    }
  },
};
</script>
